import { render, staticRenderFns } from "./UnscheduleDeliveryModal.vue?vue&type=template&id=2478e3ec"
import script from "./UnscheduleDeliveryModal.vue?vue&type=script&lang=ts"
export * from "./UnscheduleDeliveryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports